
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { COST_CENTRE_METADATA } from '../../costcentre/model/cost-centre.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class AssetsUserDetailsMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('AssetsUserDetails', {
      user: <PropertyMetadata> {
        name: 'user',
        type: 'string',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      costCentres: <PropertyMetadata> {
        name: 'costCentres',
        type: 'CostCentre',
        plural: true,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToMany,
        get relationshipEntityMetadata(): EntityMetadata {
          return COST_CENTRE_METADATA;
        },
        byReference: true,
        unique: false
      },
      landline: <PropertyMetadata> {
        name: 'landline',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 15,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      mobile: <PropertyMetadata> {
        name: 'mobile',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 15,
        unique: false
      },
      notificationSummaryEmails: <PropertyMetadata> {
        name: 'notificationSummaryEmails',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.user;
    return nullIfContainsNull(result);
  }
}



